import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Rotate90DegreesCwIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rotate_90_degrees_cw"}/>
}
